import { mapParamsBySchema } from '../../../util';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import Global from '../../../Services/Common/Global';
import Store from '../../../Store/Store';
import { WOE_BASIC_02_Schema } from './M_WOE_BASIC_02_Schema';
import useSearchMutaion from '../../../Hooks/apis/useSearchMutaion';
import useSaveMutation from '../../../Hooks/apis/useSaveMutaion';

const toDataResponse = (res) =>
  res != null && Array.isArray(res) ? { data: res } : res;

const toDataResponseFromResult = (res) => {
  const list = res?.Data ?? res?.data ?? (Array.isArray(res) ? res : []);
  return { data: Array.isArray(list) ? list : [] };
};

/** 작업후기 상세 조회 GetWoeBasicR3 */
export const useSearch1 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      WOE_BASIC_02_Schema.mapper.search1,
      context
    );
    const res = await apiRequest(
      'post',
      Global.urls.WorkEnd.getWoeBasicR3,
      params
    );
    return toDataResponseFromResult(res);
  }, successOptions);
};

/** 작업후기 저장 SaveWoeBasicU3 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (vars) => {
    const row = vars?.row ?? vars;
    const userInfo =
      vars?.userInfo ?? Store.getState()?.BaseInfo?.userInfo;
    const context = { ...row, userInfo };
    const payload = mapParamsBySchema(
      WOE_BASIC_02_Schema.mapper.save1,
      context
    );
    return apiRequest(
      'post1',
      Global.urls.WorkEnd.saveWoeBasicU3,
      payload
    );
  }, options);
};
